<template>
  <div class="p-3">
    <!-- Question Paper view -->
    <div v-if="activeView === 'questionPaper'">
      <FacultyCoeQpSets lazy />
    </div>

    <!-- Evaluations view -->
    <div v-else-if="activeView === 'evaluations'">
      <FacultyCoeEvaluations ref="facultyCoeEvaluations" lazy @breadcrumb-change="onEvaluationsBreadcrumbChange" />
    </div>

    <!-- Tile chooser -->
    <div v-else class="d-flex flex-wrap" style="gap: 16px;">
      <div class="coe-tile text-center p-4" @click="openView('questionPaper', 'Controller of Examination › Question Paper')">
        <i class="fas fa-file-alt fa-2x mb-2 text-primary"></i>
        <div class="font-weight-bold">Question Paper</div>
      </div>
      <div class="coe-tile text-center p-4" @click="openView('evaluations', 'Controller of Examination › Evaluations')">
        <i class="fas fa-user-check fa-2x mb-2 text-success"></i>
        <div class="font-weight-bold">Evaluations</div>
      </div>
    </div>
  </div>
</template>

<script>
import FacultyCoeQpSets from "./FacultyCoeQpSets.vue";
import FacultyCoeEvaluations from "./FacultyCoeEvaluations.vue";

export default {
  name: "FacultyCoeHome",

  components: { FacultyCoeQpSets, FacultyCoeEvaluations },

  data() {
    return {
      activeView: null,
    };
  },

  methods: {
    openView(view, breadcrumb) {
      this.activeView = view;
      this.$emit("breadcrumb-change", breadcrumb);
    },

    onEvaluationsBreadcrumbChange(breadcrumb) {
      this.$emit("breadcrumb-change", `Controller of Examination › Evaluations › ${breadcrumb}`);
    },

    // Called by the parent modal's back-icon. Returns true if this component
    // (or a nested child) navigated back a level itself, so the parent should
    // not close the whole modal; false if already at the root tile chooser.
    goBack() {
      if (this.activeView === "evaluations" && this.$refs.facultyCoeEvaluations && this.$refs.facultyCoeEvaluations.goBack()) {
        this.$emit("breadcrumb-change", "Controller of Examination › Evaluations");
        return true;
      }
      if (this.activeView) {
        this.activeView = null;
        this.$emit("breadcrumb-change", "Controller of Examination");
        return true;
      }
      return false;
    },
  },
};
</script>

<style scoped>
.coe-tile {
  min-width: 160px;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  cursor: pointer;
}
.coe-tile:hover {
  background-color: #f8f9fa;
}
</style>
